import { Component, OnInit } from '@angular/core';
import { ApiService } from 'app/services/api.service';
import { AnalyticsFilterService } from '../../../../services/analytics-filter.service';
import { FeedbackCustomerFilter } from '../../../../types/types';

@Component({
  selector: 'fuse-order-type-filter',
  templateUrl: './order-type-filter.component.html',
  styleUrls: ['./order-type-filter.component.scss']
})
export class OrderTypeFilterComponent implements OnInit {

  constructor(
    public analyticFilterService: AnalyticsFilterService,
    public api: ApiService,
  ) { }

  ngOnInit(): void {}

  public onChangeFilterValue = (filter: FeedbackCustomerFilter): void => {
    this.analyticFilterService.extendFilter(filter);
  }
}
